
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gongyi",
      function () {
        return require("private-next-pages/gongyi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gongyi"])
      });
    }
  